// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__17oaL","calendarButtons":"ClockData_calendarButtons__3fp2U"};